import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    wrapper: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: Spacings.s16,
    },
    links: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: Spacings.s16,
    },
    // Skeleton
    wrapperSkeleton: {
      width: '100%',
      height: 200,
    },
  },
  { name: 'color-links' },
);

export default useStyles;
